class TestimonialsVideos{

    constructor(){
        const block = document.querySelector('.block.slider-testimonials');
        if( !block ){
            return;
        }
        this.videos = [];
        this.items = document.querySelectorAll('.slider-testimonials .swiper-slide');
        this.init();
        this.currentIndex = 0;
    }

    init(){
        const _this = this;
        let i = 0;
        this.items.forEach(function(item) {
            let v = item.querySelector('video source');
            _this.videos.push({
                url: v.getAttribute('src')
            });
            let button = item.querySelector('button.btn-play');
            button.setAttribute('data-index', i);
            const __this = _this;
            button.addEventListener('click', function () {
                __this.eventclick(this);
            });
            i++;
        })
    }

    eventclick(t){
        let index = t.getAttribute('data-index');
        this.currentIndex = index;
        this.createModal();
    }

    createModal(){
        const element = document.querySelector(".testimonials-modal");
        if( element ){
            return;
        }
        const body = document.querySelector('body');
        let modal = document.createElement("div");
        modal.className = 'testimonials-modal';

        const url = this.videos[this.currentIndex].url;
        let html = `<div class="bg"></div>
            <video autoplay controls><source src="${url}" type="video/mp4"></video>`;
        modal.innerHTML = html;
        body.append(modal);

        const bd = modal.querySelector('.bg');
        bd.addEventListener('click', function(){
            modal.remove();
        })
    }
}

new TestimonialsVideos;
